import './layout.less'

import {Form, Image, action, classes} from '@codeurs/front'

import Author from 'views/layout/author'
import {AuthorType} from 'types/types'
import Button from 'views/layout/button'
import CMSPage from 'views/cmspage'
import Container from 'views/layout/container'
import Footer from 'views/partials/footer'
import Header from 'views/partials/header'
import IntroBar from 'views/partials/introbar'
import Link from 'views/layout/link'
import PublishedDate from 'views/layout/date'
import Title from 'views/layout/title'
import arrow from 'assets/icons/homearrow.svg'
import m from 'mithril'
import {t} from 'store'

export default class Layout<Data = {}> extends CMSPage<Data> {
	static showNav = false
	static form: any = new Form({})
	static render(attrs) {
		const {
			menu,
			side_menu,
			footer_menu,
			social,
			links,
			channel,
			contact,
			header_image
		} = attrs.data
		return m('.layout', [
			m(Header,
				{
					links,
					menu,
					side_menu,
					channel,
					showNav: this.showNav,
					setNav: (value: boolean) => (this.showNav = value),
					header_image,
					social
				},
				m(IntroBar, attrs.data, this.viewIntroBar(attrs))
			),
			m('.layout-content',
				m(this, {
					oncreate: () => this.scrollToTop(),
					...attrs
				})
			),
			m(Footer, {links, footer_menu, contact, social}),
			this.viewCmsLink(attrs)
		])
	}

	static scrollToTop() {
		if (window.location.hash) return
		window.scrollTo(0, 0)
	}

	static viewIntroBar(attrs: any): any {
		const {
			title,
			full_title,
			channel,
			highlight,
			publication,
			author,
			lists,
			start_date,
			date
		} = attrs.data
		switch (channel) {
			case 'homepage':
				if (!highlight)
					return m(Title,
						{class: 'layout-heading', heading: 1},
						full_title || title
					)
				return m('.intro', [
					m('.intro-highlight', [
						m('.intro-highlight-content', [
							m('p.intro-highlight-content-label', this.getLabel(highlight)),
							m(Title,
								{heading: 1, class: 'intro-highlight-content-title'},
								highlight.title
							),
							m(Link,
								{
									...action(highlight.url),
									...classes({mod: 'blue'}, 'intro-highlight-content-link')
								},
								[
									m('.intro-highlight-content-link-text',
										t('articles.readmore')
									),
									m('.intro-highlight-content-link-arrow', '>')
								]
							)
						]),
						m('a.intro-highlight-link', action(highlight.url), [
							m(Image, {
								class: 'intro-link-arrow',
								src: arrow,
								alt: 'Go to page'
							})
						])
					]),
					m('.intro-subscribe', [
						m('.intro-subscribe-wrapper', [
							m('h1.intro-subscribe-title', t('home.subscribe.title')),
							m('p.intro-subscribe-text', t('home.subscribe.text')),
							m('form.intro-subscribe-form',
								{
									onsubmit: () => {
										action.navigate('/subscribe?email=' + this.form.email)
										this.scrollToTop()
									}
								},
								[
									this.form.email({
										key: 'email',
										required: true,
										placeholder: t('home.subscribe.email'),
										className: 'intro-subscribe-form-input'
									}),
									m(Button,
										{
											type: 'submit',
											class: 'intro-subscribe-form-submit',
											mod: 'round'
										},
										t('home.subscribe.submit')
									)
								]
							)
						])
					])
				])
			case 'article':
			case 'publication':
				return m('.introarticle',
					m(Container, {...classes({mod: 'introbar-article'})}, [
						m('.introarticle-top', [
							m(Title, {heading: 1, class: 'introarticle-top-title'}, title)
						]),
						m('.introarticle-bottom', [
							date &&
								m(PublishedDate, {
									date,
									class: 'introarticle-bottom-date'
								}),
							author &&
								m(Author, {
									author: Array.isArray(author)
										? this.getAuthor(author, lists.authors)
										: author,
									...classes('introarticle-bottom-author')
								})
						])
					])
				)
			case 'policy_domain':
			case 'policy_area':
				return m(Title,
					{class: 'layout-heading', heading: 1},
					t('policies.policies')
				)
			case 'search':
				return m(Title, {class: 'layout-heading', heading: 1}, null)
			case 'event':
				return m('.introarticle',
					m(Container, {...classes({mod: 'introbar-article'})}, [
						m('.introarticle-top', [
							m(Title, {heading: 1, class: 'introarticle-top-title'}, title)
						])
					])
				)
			case 'private_events':
				return m(Title, {class: 'layout-heading', heading: 1}, '')
			default:
				return m(Title,
					{class: 'layout-heading', heading: 1},
					full_title || title
				)
		}
	}
	static getAuthor(
		authorId: Array<Number>,
		allAuthors: Array<AuthorType>
	): AuthorType {
		return allAuthors.find(o => o.id == authorId[0])
	}
	static getLabel(highlight) {
		switch (highlight.label[0]) {
			case 'other':
				return t('home.label.publication')
			case 'news':
				return t('home.label.news')
			case 'press':
				return t('home.label.press')
			case 'paper':
				return t('home.label.publication')
		}
	}
}
